(() => {
  if (window.gppProductActionsReady) return;
  window.gppProductActionsReady = true;
  const key = 'gpp:wishlist:v1';
  let saved = [];
  let storageAvailable = true;
  const validURL = (value, product = false) => {
    try {
      const url = new URL(value, location.origin);
      if (!['http:', 'https:'].includes(url.protocol)) return '';
      if (product && (url.origin !== location.origin || !url.pathname.includes('/products/'))) return '';
      return url.href;
    } catch { return ''; }
  };
  function read() {
    try {
      const data = JSON.parse(localStorage.getItem(key) || '[]');
      saved = Array.isArray(data) ? data.filter(item => item && typeof item.id === 'string' && typeof item.title === 'string' && validURL(item.url, true)).slice(0, 200) : [];
    } catch { storageAvailable = false; }
  }
  function persist() {
    try { localStorage.setItem(key, JSON.stringify(saved)); }
    catch { storageAvailable = false; }
  }
  function sync() {
    document.querySelectorAll('[data-gpp-save]').forEach(button => {
      const active = saved.some(item => item.id === button.dataset.productId);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', `${active ? 'Remove from favourites:' : 'Favourite'} ${button.dataset.productTitle}`);
      button.title = active ? 'Remove from favourites' : 'Add to favourites';
      const label = button.querySelector('span');
      if (label) label.textContent = 'Favourite';
    });
    document.querySelectorAll('[data-gpp-wishlist-count]').forEach(el => { el.textContent = saved.length > 99 ? '99+' : String(saved.length); });
    document.querySelectorAll('[data-gpp-wishlist-open]').forEach(el => { el.setAttribute('aria-label', `Wishlist, ${saved.length} saved products`); });
    document.querySelectorAll('[data-gpp-storage-warning]').forEach(el => { el.hidden = storageAvailable; });
  }
  function render() {
    const container = document.querySelector('[data-gpp-wishlist-items]');
    if (!container) return;
    container.replaceChildren();
    if (!saved.length) {
      const empty = document.createElement('p');
      empty.textContent = 'Your wishlist is empty. Tap Favourite below any product to keep it here.';
      container.append(empty);
    }
    saved.forEach(item => {
      const card = document.createElement('article');
      card.className = 'gpp-saved-card';
      const link = document.createElement('a');
      link.href = validURL(item.url, true);
      const imageURL = validURL(item.image);
      if (imageURL) {
        const image = document.createElement('img');
        image.src = imageURL; image.alt = ''; image.loading = 'lazy'; image.width = 96; image.height = 96;
        link.append(image);
      }
      const title = document.createElement('span'); title.textContent = item.title; link.append(title);
      const remove = document.createElement('button');
      remove.type = 'button'; remove.dataset.gppRemove = item.id; remove.textContent = 'Remove';
      remove.setAttribute('aria-label', `Remove ${item.title} from wishlist`);
      card.append(link, remove); container.append(card);
    });
    sync();
  }
  read();
  let opener;
  function init() {
    const dialog = document.getElementById('GppWishlist');
    if (dialog && dialog.parentNode !== document.body) {
      document.body.append(dialog);
      dialog.addEventListener('close', () => opener?.focus());
      dialog.addEventListener('click', event => { if (event.target === dialog && (event.clientX < dialog.getBoundingClientRect().left || event.clientX > dialog.getBoundingClientRect().right || event.clientY < dialog.getBoundingClientRect().top || event.clientY > dialog.getBoundingClientRect().bottom)) dialog.close(); });
    }
    sync();
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-gpp-save], [data-gpp-remove], [data-gpp-wishlist-open], [data-gpp-wishlist-close]');
    if (!button) return;
    const dialog = document.getElementById('GppWishlist');
    if (button.hasAttribute('data-gpp-wishlist-open')) {
      opener = button; render(); dialog?.showModal(); return;
    }
    if (button.hasAttribute('data-gpp-wishlist-close')) { dialog?.close(); return; }
    const id = button.dataset.gppRemove || button.dataset.productId;
    const index = saved.findIndex(item => item.id === id);
    if (index >= 0) saved.splice(index, 1);
    else if (button.hasAttribute('data-gpp-save') && validURL(button.dataset.productUrl, true)) saved.push({ id, title: button.dataset.productTitle, url: button.dataset.productUrl, image: button.dataset.productImage || '' });
    saved = saved.slice(-200);
    persist(); sync();
    const status = document.querySelector('[data-gpp-wishlist-status]');
    if (status) status.textContent = index >= 0 ? 'Product removed from wishlist.' : 'Product saved to wishlist.';
    if (dialog?.open) { render(); (dialog.querySelector('[data-gpp-remove]') || dialog.querySelector('[data-gpp-wishlist-close]'))?.focus(); }
  });
  window.addEventListener('storage', event => { if (event.key === key || event.key === null) { read(); sync(); if (document.getElementById('GppWishlist')?.open) render(); } });
  document.addEventListener('shopify:section:load', init);
  new MutationObserver(mutations => { if (mutations.some(mutation => [...mutation.addedNodes].some(node => node.nodeType === 1 && (node.matches('[data-gpp-save]') || node.querySelector('[data-gpp-save]'))))) sync(); }).observe(document.documentElement, { childList: true, subtree: true });
  async function migrateLegacyWishlist() {
    let handles;
    try {
      if (localStorage.getItem('gpp:wishlist:legacy-migrated')) return;
      handles = JSON.parse(localStorage.getItem('user_wishlist') || '[]');
      if (!Array.isArray(handles) || !handles.length) return;
      handles = [...new Set(handles.filter(handle => typeof handle === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(handle)))].slice(0, 200);
    } catch { return; }
    let failures = 0;
    for (let index = 0; index < handles.length; index += 4) {
      await Promise.all(handles.slice(index, index + 4).map(async handle => {
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}products/${encodeURIComponent(handle)}.js`);
          if (response.status === 404) return;
          if (!response.ok) throw new Error('Product lookup failed');
          const product = await response.json();
          const id = String(product.id);
          if (!saved.some(item => item.id === id)) saved.push({ id, title: product.title, url: product.url || `/products/${handle}`, image: product.featured_image || '' });
        } catch { failures += 1; }
      }));
    }
    saved = saved.slice(-200); persist(); sync();
    if (document.getElementById('GppWishlist')?.open) render();
    try { if (!failures) localStorage.setItem('gpp:wishlist:legacy-migrated', 'true'); } catch { /* Memory-only wishlist remains usable. */ }
  }
  init();
  migrateLegacyWishlist();
})();

// Native successful-add feedback. Does not intercept fetch or submit forms.
(() => {
  if (window.gppCartFeedbackInstalled) return;
  window.gppCartFeedbackInstalled = true;
  const visible = element => {
    if (!element) return false;
    const r = element.getBoundingClientRect(), style = getComputedStyle(element);
    return r.width > 0 && r.height > 0 && r.top >= 0 && r.left >= 0 && r.bottom <= innerHeight && r.right <= innerWidth && style.visibility !== 'hidden' && style.display !== 'none';
  };
  document.addEventListener('gpp:cart-add-success', event => {
    const detail = event.detail;
    if (!detail || detail.feedback) return;
    detail.feedback = (async () => {
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const card = event.target.closest('.card-wrapper, product-info, .quick-add-modal__content');
      const sources = [...(card?.querySelectorAll('img') || [])].filter(img => visible(img) && img.complete && img.naturalWidth);
      // Hover CSS may fade the sole primary image; its loaded product photo remains a genuine source.
      const image = sources.find(img => getComputedStyle(img).opacity !== '0') || sources[0];
      const target = document.querySelector('#cart-icon-bubble');
      // No invented cart destination when the real header is outside the viewport.
      if (!image || !visible(target) || !image.currentSrc) return;
      const start = image.getBoundingClientRect(), end = target.getBoundingClientRect();
      const size = Math.min(72, start.width, start.height), ghost = document.createElement('img');
      ghost.src = image.currentSrc; ghost.alt = ''; ghost.setAttribute('aria-hidden', 'true'); ghost.className = 'gpp-cart-flight';
      Object.assign(ghost.style, {left: (start.x + start.width/2 - size/2)+'px', top: (start.y + start.height/2 - size/2)+'px', width:size+'px', height:size+'px', pointerEvents:'none'});
      document.body.append(ghost);
      const dx = end.x + end.width/2 - (start.x + start.width/2), dy = end.y + end.height/2 - (start.y + start.height/2);
      let animation;
      try {
        animation = ghost.animate([
          {transform:'translate(0,0) scale(1)',opacity:.9},
          {transform:`translate(${dx*.45}px,${Math.min(dy*.55,-80)}px) scale(.7)`,opacity:.8,offset:.5},
          {transform:`translate(${dx}px,${dy}px) scale(.15)`,opacity:0}
        ], {duration:400,easing:'cubic-bezier(.2,.6,.4,1)',fill:'forwards'});
        await Promise.race([animation.finished.catch(() => {}),new Promise(resolve => setTimeout(resolve,450))]);
      } finally { animation?.cancel(); ghost.remove(); }
    })();
  });
})();
